/* FF cadou automat 500 lei – trandafir Flăcara Regală (21.10.2026) */
(function(){
  if (window.top !== window || window.__ffCadouAuto) return; window.__ffCadouAuto = 1;
  var VID = 54339689906523, PRAG = 50000, MSG = '🎁 Ai primit cadou trandafirul Flăcara Regală';
  var SK = 'ffCadouAutoTs', busy = false, again = false, t = null;
  var log = function(){ try{ console.log.apply(console, ['[ff-cadou]'].concat([].slice.call(arguments))); }catch(e){} };
  var of = window.fetch;
  function isGift(i){ return i.variant_id === VID; }
  function j(u, b){ return of(u, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json','X-FF-Cadou':'1'}, body:JSON.stringify(b)}).then(function(r){ return r.json(); }); }
  function toast(){
    var d = document.getElementById('ff-cadou-toast');
    if (!d){ d = document.createElement('div'); d.id='ff-cadou-toast'; d.setAttribute('role','status');
      d.style.cssText='position:fixed;left:50%;bottom:20px;transform:translateX(-50%);z-index:2147483000;background:#1f6b3a;color:#fff;padding:12px 16px;border-radius:10px;font:600 15px/1.3 system-ui,sans-serif;box-shadow:0 4px 16px rgba(0,0,0,.25);max-width:92vw;text-align:center';
      document.body.appendChild(d); }
    d.textContent = MSG; d.style.display='block'; clearTimeout(d._t); d._t = setTimeout(function(){ d.style.display='none'; }, 5000);
  }
  function refresh(cart){
    try {
      if (window.kachingCartApi && window.kachingCartApi.refreshCart) { try { window.kachingCartApi.refreshCart(); } catch(e){} }
      document.dispatchEvent(new CustomEvent('cart:update', {bubbles:true, detail:{resource:cart, sourceId:'ff-cadou', data:{source:'ff-cadou', itemCount:cart && cart.item_count}}}));
      // re-render secțiuni coș (Horizon / Dawn-like)
      var ids = []; document.querySelectorAll('[id^="shopify-section-"]').forEach(function(s){ if (/cart/i.test(s.id)) ids.push(s.id.replace('shopify-section-','')); });
      if (!ids.length) return;
      of(window.location.pathname + '?sections=' + ids.slice(0,5).join(',')).then(function(r){ return r.json(); }).then(function(h){
        Object.keys(h||{}).forEach(function(id){ var el = document.getElementById('shopify-section-'+id); if (!el || !h[id]) return;
          var n = new DOMParser().parseFromString(h[id], 'text/html').getElementById('shopify-section-'+id); if (n) el.innerHTML = n.innerHTML; });
      }).catch(function(){});
    } catch(e){}
  }
  function run(){
    if (busy){ again = true; return; }
    busy = true;
    of('/cart.js', {headers:{'Accept':'application/json'}, cache:'no-store'}).then(function(r){ return r.json(); }).then(function(c){
      var gifts = c.items.filter(isGift), sub = 0;
      c.items.forEach(function(i){ if (!isGift(i)) sub += i.final_line_price; });
      var qg = gifts.reduce(function(a,i){ return a + i.quantity; }, 0);
      log('subtotal fara cadou', sub/100, 'cadou qty', qg);
      if (sub >= PRAG){
        if (qg === 0){
          var last = +sessionStorage.getItem(SK) || 0;
          if (Date.now() - last < 4000) return null;   // anti-dublare între taburi/reîncărcări
          sessionStorage.setItem(SK, Date.now());
          return j('/cart/add.js', {items:[{id:VID, quantity:1, properties:{_cadou:'1'}}]}).then(function(){ return of('/cart.js').then(function(r){ return r.json(); }); }).then(function(nc){ toast(); refresh(nc); });
        }
        if (qg > 1 || gifts.length > 1){
          var upd = {}; gifts.forEach(function(g, k){ upd[g.key] = k === 0 ? 1 : 0; });
          return j('/cart/update.js', {updates:upd}).then(function(nc){ refresh(nc); });
        }
      } else if (qg > 0){
        var u = {}; gifts.forEach(function(g){ u[g.key] = 0; });
        sessionStorage.removeItem(SK);
        return j('/cart/update.js', {updates:u}).then(function(nc){ refresh(nc); });
      }
    }).catch(function(e){ log('eroare', e); }).then(function(){
      busy = false; if (again){ again = false; schedule(); }
    });
  }
  function schedule(){ clearTimeout(t); t = setTimeout(run, 350); }
  var re = /\/cart\/(add|change|update|clear)(\.js|\.json)?/;
  window.fetch = function(u, o){
    var p = of.apply(this, arguments);
    try { var url = typeof u === 'string' ? u : (u && u.url) || '';
      var own = o && o.headers && (o.headers['X-FF-Cadou'] || (o.headers.get && o.headers.get('X-FF-Cadou')));
      if (re.test(url) && !own) p.then(schedule, schedule); } catch(e){}
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(m, u){ if (re.test(u||'')) this.addEventListener('loadend', schedule); return xo.apply(this, arguments); };
  ['cart:update','cart:updated','cart:refresh','cart-drawer:open','theme:cart:change'].forEach(function(e){
    document.addEventListener(e, function(ev){ if (ev.detail && ev.detail.sourceId === 'ff-cadou') return; schedule(); });
  });
  window.addEventListener('pageshow', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
